// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v70M","index":"styles_index__15LH0"};